/**
 * Convert a range data to a basic name data
 * Range look like Poissons!A1:Y37, basic name data should look like Poissons
 * @param range
 * @return string
 */
export function convertRangeToName (range: string) {
    return range.split('!')[0].replace(/'/g, "");
}
